import { buildPathFromPattern } from '@/core/route-utils'
import { workspaceModules, ModuleConfig } from './workspace-modules'
import { ChevronRight } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

const ModuleCard = ({ mod, url }: { mod: ModuleConfig & { key: string }, url: string }) => {
    const img = mod.image?.toString()

    return (
        <a href={url} className={cn("block group w-full outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-[24px]", mod.isEnabled === false && "opacity-50 pointer-events-none")}>
            <div className="relative w-full aspect-[3/4] rounded-[24px] overflow-hidden border border-white/10 bg-[#0f0f11] shadow-xl transition-all duration-500 hover:shadow-2xl hover:border-primary/40 hover:-translate-y-2 cursor-pointer">

                {/* Badge (Top Left Corner) */}
                <div className="absolute top-4 left-4 z-10 inline-flex items-center gap-1.5 rounded-full bg-white/10 backdrop-blur-md px-3 py-1.5 border border-white/20 shadow-sm transition-transform duration-500 group-hover:scale-105">
                    <span className="text-[14px] leading-none">
                        {mod.emoji}
                    </span>
                </div>

                {/* Image Background */}
                <div
                    className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 group-hover:scale-[1.03] opacity-80 mix-blend-screen"
                    style={{ backgroundImage: `url(${img})` }}
                />

                {/* Advanced Gradients for Mood & Vignette */}
                <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-500" />
                <div className="absolute inset-x-0 bottom-0 h-3/4 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />

                {/* Inner Glow Border */}
                <div className="absolute inset-0 rounded-[24px] ring-1 ring-inset ring-white/10 transition-all duration-500 group-hover:ring-white/20 pointer-events-none" />

                {/* Content Container */}
                <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8 flex flex-col justify-end">

                    {/* Hover Lift Group */}
                    <div className="transform transition-transform duration-500 ease-out group-hover:-translate-y-2">

                        {/* Title */}
                        <h3 className="text-3xl font-extrabold tracking-tight text-white drop-shadow-xl mb-2 line-clamp-3 leading-snug">
                            {mod.name}
                        </h3>

                        {/* Description (Visible on Hover) */}
                        <p className="text-white/90 text-[15px] leading-relaxed line-clamp-2 h-0 opacity-0 overflow-hidden transition-all duration-500 ease-out group-hover:h-auto group-hover:opacity-100 group-hover:mt-2 drop-shadow-md">
                            {mod.description}
                        </p>

                        {/* Hover Action */}

                    </div>
                </div>
            </div>
        </a>
    )
}

const ModuleList = ({ project_id }: { project_id: string }) => {
    const modules = Object.entries(workspaceModules).map(([key, moduleConfig]) => {
        return { ...moduleConfig, key }
    })
    return (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 py-6">
            {modules.map((mod, i) => {
                const url = buildPathFromPattern(mod.routePattern, { project_id })
                return <ModuleCard key={i} mod={mod} url={url} />
            })}
        </div>
    )
}

export default ModuleList
